import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useZoom } from "../context/ZoomContext";

export default function Header() {
  const [q, setQ] = useState("");
  const [filterOpen, setFilterOpen] = useState(false);
  const navigate = useNavigate();
  const { zoomIn, zoomOut } = useZoom();

  const submit = (e) => {
    e.preventDefault();
    if (q.trim()) navigate(`/search?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <header data-testid="header-nav" className="sticky top-0 z-50 bg-bg">
      <div className="px-3 md:px-4 h-16 flex items-center gap-3">
        <Link to="/" data-testid="header-logo" className="ab-logo shrink-0 relative" title="AK.ARCHIVE">
          AK
          <span className="rec-dot absolute -top-0.5 -right-0.5" />
        </Link>

        <div className="hidden md:flex items-center gap-2 ml-2">
          <button onClick={zoomIn} data-testid="zoom-in" className="pill pill-icon" title="Zoom in">＋</button>
          <button onClick={zoomOut} data-testid="zoom-out" className="pill pill-icon" title="Zoom out">－</button>
          <span className="pill pill-yellow pill-sm" data-testid="zoom-label">ZOOM</span>
        </div>

        <nav className="hidden lg:flex items-center gap-2 ml-2">
          <NavLink to="/" end data-testid="nav-vault" className={({isActive}) => `pill pill-sm ${isActive ? "pill-yellow" : ""}`}>Vault</NavLink>
          <NavLink to="/dossiers" data-testid="nav-dossiers" className={({isActive}) => `pill pill-sm ${isActive ? "pill-yellow" : ""}`}>Dossiers</NavLink>
          <NavLink to="/new" data-testid="nav-new" className={({isActive}) => `pill pill-sm ${isActive ? "pill-yellow" : ""}`}>New</NavLink>
        </nav>

        <div className="flex-1" />

        <form onSubmit={submit} className="hidden md:flex items-center" data-testid="header-search-form">
          <input
            data-testid="header-search-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search archive…"
            className="input-mono w-[220px] lg:w-[260px]"
          />
        </form>

        <button
          onClick={() => setFilterOpen((v) => !v)}
          data-testid="header-filter-toggle"
          className={`pill ${filterOpen ? "pill-active" : ""}`}
        >
          Filter
        </button>

        <Link to="/admin/login" data-testid="header-admin-link" className="pill">
          Info
        </Link>
      </div>

      {filterOpen && (
        <div className="hairline-t hairline-b bg-bg px-4 py-3 flex flex-wrap gap-2 items-center" data-testid="header-filter-drawer">
          <span className="label-overline mr-2">// FILTER BY DOSSIER</span>
          <FilterLinks />
        </div>
      )}
    </header>
  );
}

const FilterLinks = () => {
  // simple filter links to dossiers listing / recent
  const links = [
    { to: "/dossiers", label: "All Dossiers" },
    { to: "/new", label: "New Arrivals" },
  ];
  return (
    <>
      {links.map((l) => (
        <NavLink key={l.to} to={l.to} className={({ isActive }) => `pill pill-sm ${isActive ? "pill-active" : ""}`}>
          {l.label}
        </NavLink>
      ))}
    </>
  );
};
